import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";

import { useropen } from '../../redux/userInfo';
import { open, close } from '../../redux/popupSlice';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';
import Radios from '../../component/Radios';

import { getMemberinfo, regPhone, patternPwCker } from "../../utils/utils";

export default function Storeselctor({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [mb_id, setmb_id] = useState('');   
    const [seltype, setseltype] = useState('');   
    const [memberinfos, setmemberinfos] = useState(''); 

    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);



    return(
        <Layout header={false}>
            <div className='normalformw1000 heightgap40'>
                <div className="pageinfoNumbering">
                    <b>01</b>/ 02
                </div>
                <div className='normalformw1000_title'>서비스 이용을 위해 사무소 정보를 등록해 주세요.</div>
                <div className='storeSelectors'>
                    <div 
                        onMouseOver={() => { setseltype(0); }} onMouseOut={() => { setseltype(''); }}
                        onClick={() => navigate('/Storetype1Write', {state: {level: 3}} )}
                        style={{
                            border: `1px solid #${seltype === 0 ? '6164A5' : 'DDD'}`
                        }}
                    >
                        <div>
                            <p>대표 사업자가 있는</p>
                            <p style={{ color: `#${seltype === 0 ? '6164A5' : '333'}` }}>대표 공인중개사</p>
                        </div>
                        <div>
                            <img src={`./images/icons/storesel_${seltype === 0 ? 'on' : 'off'}_1.svg`} style={{ width: 162, height: 160 }} />
                        </div>
                    </div>
                    <div 
                        onMouseOver={() => { setseltype(1); }} onMouseOut={() => { setseltype(''); }}
                        onClick={() => navigate('/Storetype2Write', {state: {level: 2, registerName: memberinfos?.name}} )}
                        style={{
                            border: `1px solid #${seltype === 1 ? '6164A5' : 'DDD'}`
                        }}                        
                    >
                        <div>
                            <p>사무소에 소속되어 있는</p>
                            <p style={{ color: `#${seltype === 1 ? '6164A5' : '333'}` }}>소속 공인중개사</p>
                        </div>
                        <div>
                            <img src={`./images/icons/storesel_${seltype === 1 ? 'on' : 'off'}_2.svg`} style={{ width: 162, height: 160 }} />
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

